import React from 'react'
import { useNavigate } from 'react-router-dom'

const ChannelItem = ({
  channel = {},
  unreadCount = 0,
  onSelect,
  isDm = false,
  readReceipts = [],
  setReadReceipts,
  readReceiptsRef,
  userAvatars = []
}) => {
  const navigate = useNavigate()
  const channelId = channel?._id || ''
  const channelName = (channel?.name?.split?.('_')[0] || 'Unnamed')
  const displayName = channelName
    ? channelName.charAt(0).toUpperCase() + channelName.slice(1)
    : 'Unnamed'

  const threadUnreadCount = channel?.threadUnreadCount || 0

  const handleClick = () => {
    if (!channelId) return
    onSelect?.(channelId)
    navigate(`/chat/${channelId}`, {
      state: {
        unreadCount,
        setReadReceipts,
        readReceipts,
        readReceiptsRef,
        isDm,
        channelThreadUnreadCount: threadUnreadCount,
        channelData: channel,
        channelName: displayName,
        userAvatars
      }
    })
  }

  return (
    <div
      className="channel-item"
      key={channelId}
      onClick={handleClick}
      tabIndex={0}
      role="button"
      aria-label={`Open channel ${displayName}`}
      style={{ outline: 'none' }}
    >
      <div className="channel-name-badge">
        <span className="channel-name">{displayName}</span>
        {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
        {/* {threadUnreadCount > 0 && <span className="thread-badge">{threadUnreadCount}</span>} */}
      </div>
    </div>
  )
}

export default ChannelItem
